export default function(){
  let _this = this;
  let ga_matrix = {};
  ga_matrix['sitesection1']='dimension5';
  ga_matrix['sitesection2']='dimension1';
  ga_matrix['sitesection3']='dimension3';
  ga_matrix['sitesection4']='dimension6';
  ga_matrix['aboutness']='dimension13';

  ga_matrix['pagename']='dimension7';
  ga_matrix['pubdate']='dimension4';
  ga_matrix['contentid']='dimension9';
  ga_matrix['contenttype']='dimension2';
  ga_matrix['contenthierachy']='dimension8';
  ga_matrix['author']='dimension14';
  ga_matrix['formtype']='dimension16';
  ga_matrix['advertisername']='dimension17';
  ga_matrix['category_id']='dimension18';

  ga_matrix['userdemographic']='dimension19';
  ga_matrix['userid']='dimension10';
  ga_matrix['usertype']='dimension11';
  ga_matrix['userentitlement']='dimension12';
  ga_matrix['authstatus']='dimension15';

  window.addEventListener("dsb-pwa-page_view", e => {
    try
    {
      if (typeof ga === 'function')
      {
        let customDimensions = {};
        let page_url = location.pathname+location.hash;
        // gwa_pageName & gwa_aboutness & gwa_contentType & gwa_ContentId & gwa_author
        if('detail' in e)
        {
          if('append' in e.detail)
          {
            page_url = page_url+"/-/"+e.detail.append;
          }

          if('customDimensions' in e.detail)
          {
            customDimensions = e.detail.customDimensions;
          }
          else if('gwa' in e.detail)
          {
            customDimensions = e.detail.gwa;
          }

          if('date' in e.detail && !('pubdate' in customDimensions))
          {
            customDimensions.pubdate = e.detail.date;
          }

          if('id' in e.detail && !('contentid' in customDimensions))
          {
            customDimensions.contentid = e.detail.id;
          }

          if('author' in e.detail && !('author' in customDimensions))
          {
            customDimensions.author = e.detail.author;
          }

          if('taxonomies' in e.detail && !('aboutness' in customDimensions))
          {
            customDimensions.aboutness = [];
            if(e.detail.taxonomies !== null && typeof Array.isArray(e.detail.taxonomies))
            {
              let sitesection_count = 2;
              for(let i = 0; i < e.detail.taxonomies.length; i++)
              {
                if(sitesection_count<5)
                {
                  customDimensions['sitesection'+sitesection_count] = e.detail.taxonomies[i];
                }
                customDimensions.aboutness.push(e.detail.taxonomies[i]);
                sitesection_count++;
                }
            }
          }

          if('types' in e.detail && !('contenttype' in customDimensions))
          {
            customDimensions.contenttype = [];
            if(e.detail.types !== null && Array.isArray(e.detail.types))
            {
              for(let i = 0; i < e.detail.types.length; i++)
              {
                customDimensions.contenttype.push(e.detail.types[i]);
              }
            }
          }

          if('title' in e.detail)
          {
            customDimensions['contenttitle'] = e.detail.title;
            _this._update_DocumentTitle(customDimensions['contenttitle']);
            ga('set', 'title', customDimensions['contenttitle']);
          }
        }

        // Add user dimensions
        customDimensions = this.dsbClient.user._updateCustomDimensions(customDimensions);


        //customDimensions.account = 'account';

        // Set defaults
        customDimensions.sitesection1 = 'fwi-pwa';

        if(!('contenthierachy' in customDimensions))
        {
          customDimensions.contenthierachy = [];
          customDimensions.contenthierachy.push(customDimensions.sitesection1);

          // Setup contenthierachy
          let contenthierachy_parts = ['sitesection2','sitesection3','sitesection4','contenttitle'];
          for(let i = 0; i < contenthierachy_parts.length; i++)
          {
            if(contenthierachy_parts[i] in customDimensions)
            {
              customDimensions.contenthierachy.push(customDimensions[contenthierachy_parts[i]]);
            }
          }
          customDimensions.contenthierachy = customDimensions.contenthierachy.join('|');
        }

        if(!('pagename' in customDimensions))
        {
          customDimensions.pagename = customDimensions.contenthierachy;
        }

        // Collapse aboutness
        if(!('aboutness' in customDimensions) || (Array.isArray(customDimensions.aboutness) && customDimensions.aboutness.length == 0))
        {
          // Set Aboutness
          customDimensions.aboutness = [];

          if('sitesection2' in customDimensions)
          {
            customDimensions.aboutness.push(customDimensions.sitesection2);
          }
          if('sitesection3' in customDimensions)
          {
            customDimensions.aboutness.push(customDimensions.sitesection3);
          }
          if('sitesection4' in customDimensions)
          {
            customDimensions.aboutness.push(customDimensions.sitesection4);
          }
        }
        if(Array.isArray(customDimensions.aboutness))
        {
          customDimensions.aboutness = customDimensions.aboutness.join('|');
        }

        // Collapse contenttype
        if(!('contenttype' in customDimensions) || (Array.isArray(customDimensions.contenttype) && customDimensions.contenttype.length == 0))
        {
          // Set contenttype
          customDimensions.contenttype = [];
          customDimensions.contenttype.push('unknown');
        }
        if(Array.isArray(customDimensions.contenttype))
        {
          customDimensions.contenttype = customDimensions.contenttype.join('|');
        }

        // Remove contenttitle (not used)
        if('contenttitle' in customDimensions)
        {
          delete customDimensions['contenttitle'];
        }


        for(let aDimensions in customDimensions)
        {
          if(typeof customDimensions[aDimensions] == 'string')
          {
            customDimensions[aDimensions] = customDimensions[aDimensions].toLowerCase();
          }

          if(aDimensions.toLowerCase() in ga_matrix)
          {
            ga('set', ga_matrix[aDimensions.toLowerCase()], customDimensions[aDimensions]);
          }
          else
          {
            console.error('dsb-pwa-page_view:: Unknown customDimension (GWA) tag "'+aDimensions+'"!',ga_matrix);
          }
        }

        console.debug('dsb-pwa-page_view::',customDimensions);

        ga('set', 'page', page_url);
        ga('send', 'pageview')
      }
      else
      {
        console.error('dsb-pwa-page_view:: GA is not available');
      }
    }
    catch(ex)
    {
      console.error('dsb-pwa-page_view:: Error occured in detail',ex);
    }
  });
}
